import JbButton from "@jbhi-fi/lanyard-ui/components/Button/Button";
import { Props as ButtonProps } from "@jbhi-fi/lanyard-ui/components/Button/Button";
import { FC } from "react";

export const Button: FC<ButtonProps> = (props: ButtonProps) => {
  return <JbButton {...props} style={{ cursor: props.disabled ? "not-allowed" : "pointer", ...props.style }} />;
};
